import { useContext, useEffect, useState } from 'react'
import Minus from "../../../../Assets/MinusCheckbox.svg";
import TickMark from '../../../../Assets/Modals/TickMark.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PlusIcon from "../../../../Assets/PlusIcon/Add.svg";
import { CustomCollectionContext } from '../../../../Context/Collections/CustomCollectionContext';
import CustomCollectionBar from './CustomCollectionBar';
import { setModal } from '../../../../Features/collectionsSlice';
import Modal from './Modal/Modal';

function CustomCollections() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [checkboxType, setCheckboxType] = useState('');

    const { selectedCustomCollections, setSelectedCustomCollections } = useContext(CustomCollectionContext);

    const customCollections = useSelector((state) => state.collections.customCollections.customCollections);

    const handleCheckboxClick = () => {
        if(selectedCustomCollections.length < customCollections.length) {
            if(selectedCustomCollections.length === 0) {
                let listId = customCollections.map(item => item.id);
                setSelectedCustomCollections(listId);
            }
            else {
                setSelectedCustomCollections([]);
            }
        }
        else {
            setSelectedCustomCollections([]);
        }
    }

    useEffect(() => {
        if(selectedCustomCollections.length < customCollections?.length) {
            if(selectedCustomCollections?.length === 0) {
                setCheckboxType('');
            }
            else {
                setCheckboxType('half')
            }
        }
        else if(selectedCustomCollections?.length === 0) {
            setCheckboxType('');
        }
        else {
            setCheckboxType('full');
        }
    }, [selectedCustomCollections, customCollections]);

    const handleAddCustomcollection = () => {
        if(selectedCustomCollections.length > 0) {
            setSelectedCustomCollections([]);
        }
        navigate(`${location.pathname}/custom-collections/add-custom-collection`);
    }

    const handleDeleteList = () => {
        dispatch(setModal('delete-confirm'));
    }

    const handleHideList = () => {
        dispatch(setModal('hide-confirm'));
    }
    
    return (
        <div className="flex flex-col mt-6 mx-5">
            <div className="flex bg-[#F5F5F5] font-semibold text-[#121212] text-[16px] leading-8">
                <div className="flex items-center gap-2 w-[calc((54/100)*(100%-44px))] px-[10px] py-[8px]">
                    {
                        customCollections.length > 0 &&
                        <div onClick={handleCheckboxClick} className={`cursor-pointer size-6 bg-[#FFFFFF] flex items-center justify-center rounded-md border ${checkboxType !== '' ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                            <img className='select-none' src={checkboxType === 'full' ? TickMark : checkboxType === '' ? undefined : Minus} alt="" />
                        </div>
                    }

                    <h2 className="">Custom Collections</h2>
                </div>

                <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[8px]">Total Product(s)</h2>
                <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[8px]">Duration</h2>
                <h2 className="w-[calc((10/100)*(100%-44px))] px-[10px] py-[8px]">Mark Active</h2>
                <div className="w-[44px]"></div>
            </div>

            {[ ...customCollections ]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map(customCollection => {
                const isSelected = selectedCustomCollections.includes(customCollection.id);
                let duration;
                if(customCollection.startDuration && customCollection.endDuration) {
                    const futureDate = new Date(customCollection.endDuration);
                    const currentDate = new Date();
                    const differenceInMillis = futureDate - currentDate;
                    duration = Math.floor(differenceInMillis / (1000 * 60 * 60 * 24));
                }

                return (
                    <CustomCollectionBar 
                        key={customCollection.id} 
                        customCollection={customCollection} 
                        isSelected={isSelected} 
                        duration={duration} 
                    />
                )
            })}

            {
                customCollections.length === 0 && 
                <div className="mx-auto mt-20 flex flex-col items-center gap-6 w-3/5">
                    <div className="flex flex-col gap-2 text-[#666666] items-center">
                        <h1 className='font-semibold text-[18px] leading-7'>No custom collection are added yet</h1>

                        <p className='text-center font-medium text-[16px] leading-7'>This is a collection that you showcase in your store section as a custom category. Examples include "New Arrivals," "Flash Sales," and more.</p>
                    </div>

                    <button onClick={handleAddCustomcollection} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                        <div className="size-6 flex items-center justify-center">
                            <img src={PlusIcon} alt="" />
                        </div>

                        Add Custom Collection
                    </button>
                </div>
            }

            {
                selectedCustomCollections.length > 0 && 
                <div className="fixed left-1/2 -translate-x-1/2 bottom-12 border border-[#EAEAEA] bg-[#F5F5F5] rounded-xl p-4 flex items-center gap-3">
                    <p className='font-medium text-[14px] leading-5 text-[#121212]'>{selectedCustomCollections.length}/{customCollections.length}</p>

                    <button onClick={handleDeleteList} className='px-4 py-2 rounded bg-[#FFFFFF] font-semibold text-base text-[#808080] outline-none select-none'>Delete</button>

                    <button onClick={handleHideList} className='px-4 py-2 rounded bg-[#FFFFFF] font-semibold text-base text-[#808080] outline-none select-none'>Hide</button>
                </div>
            }

            <Modal />
        </div>
    );
}

export default CustomCollections;
